import { Skeleton } from 'components/Skeleton/Skeleton'
import cx from 'classnames'

import Styles from './ShareSheet.module.scss'

export const LoadingHeader = () => {
  return (
    <div>
      <div className={cx(Styles.loadingRow, Styles.flush)}>
        <Skeleton avatar title={{ width: 250 }} paragraph={false} active />
      </div>
    </div>
  )
}
